var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.531.188C7.193.188 8.682.86 10 2.207 11.318.861 12.807.187 14.469.187c1.432 0 2.65.516 3.652 1.547 1.003 1.003 1.504 2.206 1.504 3.61 0 .573-.143 1.16-.43 1.761-.286.573-.573 1.003-.86 1.29l-.429.386-7.39 7.477-.516.515-.516-.515-7.39-7.477a6.077 6.077 0 0 1-.86-.988c-.573-.86-.859-1.676-.859-2.45 0-1.403.501-2.606 1.504-3.609C2.882.704 4.099.188 5.53.188Zm0 1.375c-1.031 0-1.919.372-2.664 1.117-.745.744-1.117 1.632-1.117 2.664 0 .487.2 1.045.602 1.676l.687.816L10 14.796l6.96-6.96c.86-.945 1.29-1.776 1.29-2.492 0-1.032-.372-1.92-1.117-2.664-.745-.745-1.633-1.118-2.664-1.118-.602 0-1.232.172-1.89.516-.66.315-1.175.645-1.548.988l-.515.473-.516.602-.516-.602a6.648 6.648 0 0 0-.601-.516c-.23-.229-.702-.53-1.418-.902-.688-.372-1.332-.558-1.934-.558Z",
    fill: "currentColor"
  })));
};

export default SvgHeart;